import { Typography } from '@material-ui/core';

const Copyright = () => (
  <Typography variant="body2" color="textSecondary" align="center">
    {'Copyright © '}PerfectDeed {new Date().getFullYear()}.
  </Typography>
);

export default Copyright;
